<template>
  <div
    class="header"
    :class="headerCls">
    <div class="left">
      <div v-if="isLogo">
        <span
          class="logo-img"
          :style="`background-image: url(${isLogo})`"></span>
      </div>
      <div
        class="logo"
        v-else>
        智慧公交城乡一体化平台
      </div>
    </div>
    <div class="right">
      <div>
        <a
          href="javascript:;"
          class="home-btn"
          @click="$router.push(`/cloud`)">
          <i class="iconfont icon-shouye"></i>
        </a>
        <Notice
          v-if="isNoPermission && this.user.userId"
          class="header-notice"
          :token="token"
          :fetch="fetch"
          :ws-url="wsUrl"
          :corp-id="corpId"
          :enterprise="{}"
          affirmant="无"
          :user-id="user.userId"
          :dict-util="{}"
          :business-id="businessId"
        />
        <Divider type="vertical" />
        <Dropdown
          trigger="click"
          @on-click="corpDropdownClick">
          <div class="dropdown-menu-btn">
            {{ currentCorp.corpName }}
            <Icon type="ios-arrow-down"></Icon>
          </div>
          <DropdownMenu slot="list">
            <DropdownItem
              v-for="(item, index) in corporationList"
              :key="index"
              :name="item.corpId"
            >
              {{ item.corpName }}
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
        <Divider type="vertical" />
        <Dropdown
          trigger="click"
          @on-click="userDropdownClick">
          <div class="dropdown-menu-btn">
            <img
              v-if="user.avatar"
              :src="user.avatar" />
            <img
              v-else
              src="data:image/png;base64,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"
            />
            {{ user.username||"数据读取中..." }}
            <Icon type="ios-arrow-down"></Icon>
          </div>
          <DropdownMenu slot="list">
            <DropdownItem name="user">
              个人中心
            </DropdownItem>
            <DropdownItem name="logout">
              退出登录
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import {getCookieInfo, removeCookieInfo, logout} from '@/util';
import {getCorpId} from '@/store/modules/user';
import {vueComponentLoader} from '../../util/loader';
import fetch from '../../util/fetch';
import {wsUrl} from '@/global';
import dict from '@/util/dict';


export default {
  name: 'LayoutHeader',
  components: {
    Notice: vueComponentLoader('z-notice'),
  },
  props: {
    hasBgColor: Boolean,
  },
  data() {
    return {
      wsUrl,
      fetch,
      businessId: 20200001,
      isNoPermission: false,
      corpId: getCorpId(),
    };
  },
  computed: {
    user() {
      return this.$store.getters['user/user'];
    },
    corporationList() {
      return this.$store.getters['user/corporationList'];
    },
    currentCorp() {
      return this.$store.getters['user/currentCorp'];
    },
    isLogo() {
      return this.currentCorp.corpLogo;
    },
    headerCls() {
      return this.hasBgColor ? 'bg-color' : '';
    },
    token() {
      return getCookieInfo().token;
    },
  },

  mounted() {
    const {token} = getCookieInfo();
    if (token) {
      this.$store.dispatch('user/init');
      this.isNoPermission = true;
      dict.init().then(()=> {}).catch((error)=> {
        console.log('查询字典接口失败：' + error);
      });
    } else {
      logout();
    }
  },

  methods: {
    go(path) {
      this.$router.push(path);
    },
    corpDropdownClick(corpId) {
      if (corpId+ '' === getCorpId()) {
        return;
      }
      this.isNoPermission = false;
      const corp = this.corporationList.find((item) => item.corpId === corpId);
      this.$store.dispatch('user/setCurrentCorpAndAppList', corp);
      this.$nextTick(()=> {
        this.corpId = corpId;
        this.isNoPermission = true;
      });
    },
    userDropdownClick(name) {
      switch (name) {
        case 'user':
          this.go(`/user/base-info`);
          break;
        case 'logout':
          removeCookieInfo();
          logout();
          break;
      }
    },
  },
};
</script>


<style lang="scss" scoped>
  ::v-deep{
    .ivu-select-dropdown {
      max-width: 160px;
      .ivu-dropdown-item {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

    }
  }
  .logo-img{
  display: inline-block;
  width: 185px;
  height: 30px;
  background: no-repeat 100%;
  background-size: 100%;
}
</style>
